import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { toast } from "react-toastify";
import { taxdropdown } from "../../../api/DeductionItemApi";
import {
  getBulkDropdownData,
  getFieldValuesByTableAndId,
  getOtherRefSearchDropdown,
  getTextByValueAndKey,
} from "../../../api/keyvalue";
import Grid from "../../Grid";
import Button from "../../input/Button";
import Dropdown from "../../input/Dropdown";
import SearchDropdown from "../../input/SearchDropdown";
import LoadingSpinner from "../../LoadingSpinner";
import ButtonRenderer from "../../renderer/ButtonRenderer";
import {
  ActiveCellStyle,
  ResizableScrollingTextRenderer,
  StatusCellStyle,
} from "../../renderer/StyleRenderer";
import DeleteButtonRenderer from "../../renderer/DeleteButtonRenderer";

const ItemTaxForm = forwardRef(({ editMode, currentValues, opeTyped }, ref) => {
  const [selectedTaxes, setSelectedTaxes] = useState([]);

  useEffect(() => {
    if (editMode && currentValues && currentValues.length > 0) {
      setSelectedTaxes(
        currentValues?.map((tax) => ({
          chtId: tax.chtId,
          itemTax: tax.chtTax,
          taxName: tax.taxName,
          itemReference: tax.chtReferance,
          status: tax.chtStatus,
          active: tax.chtActive,
          activeLabel: tax.activeName,
          statusLabel: tax.statusName,
          chtCustomer: tax.chtCustomer,
          chtDefault: tax.chtDefault === true ? 1 : 2,
          chtDefaultLabel: tax.chtDefault === true ? "Yes" : "No",
          chtCustomerlabel: tax.customerName,
          chtStakeType: tax.chtStakeType,
        })),
      );
    }
  }, [editMode, currentValues]);

  useImperativeHandle(ref, () => ({
    getData: () => ({
      selectedTaxes,
    }),
    resetForm: () => {
      setButtonClicked(true);
      setSelectedTaxes([]);
      resetForm();
    },
  }));

  const [currentTax, setCurrentTax] = useState({});
  const [buttonClicked, setButtonClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formFieldReset, setFormFieldReset] = useState(false);
  const [itemStatusOpt, setItemStatusOpt] = useState([]);
  const [itemActiveOpt, setItemActiveOpt] = useState([]);
  const [itemTaxOpt, setItemTaxOpt] = useState([]);
  const [itemTaxErrors, setItemTaxErrors] = useState({});
  const [yesNoOptions, setYesNoOptions] = useState([]);
  const [rowCount, setRowCount] = useState(1);
  const [stakeholderTypes, setStakeholderTypes] = useState([]);
  const customerRef = useRef();

  const [taxEntry, setTaxEntry] = useState({
    itemTax: null,
    itemReference: "",
    taxName: "",
    status: 2,
    statusLabel: "",
    active: 1,
    activeLabel: "",
    chtDefault: 1,
    chtDefaultLabel: "",
    chtCustomer: null,
    chtCustomerlabel: "",
    chtStakeType: null,
  });

  useEffect(() => {
    (async () => {
      setIsLoading(true);

      const {
        status,
        active,
        yesno: yesnoOpt,
        "stakeholder_type#charge_tax": stakeTypes,
      } = await getBulkDropdownData([
        { key: "status" },
        { key: "active" },
        { key: "yesno" },
        { key: "stakeholder_type", group: "charge_tax" },
      ]);

      setItemStatusOpt(status);
      setItemActiveOpt(active);
      setYesNoOptions(yesnoOpt);
      setStakeholderTypes(stakeTypes);

      const tax = await taxdropdown();
      setItemTaxOpt(tax);

      setIsLoading(false);
    })();
  }, []);

  const validateTaxForm = () => {
    let errors = {};
    if (!taxEntry.itemTax || taxEntry.itemTax === null) {
      errors = {
        ...errors,
        itemTax: "Tax is required",
      };
    }

    if (!taxEntry.status) {
      errors = {
        ...errors,
        itemStatus: "Status is required",
      };
    }

    if (!taxEntry.active) {
      errors = {
        ...errors,
        itemActive: "Active is required",
      };
    }

    // if (!taxEntry.itemReference) {
    //   errors = {
    //     ...errors,
    //     itemTaxReference: "Tax Reference is required",
    //   };
    // }

    if (!taxEntry.chtDefault) {
      errors = {
        ...errors,
        chtDefault: "Default is required",
      };
    }

    if (taxEntry.chtDefault === 2 || taxEntry.chtDefault === false) {
      if (!taxEntry.chtCustomer) {
        errors = {
          ...errors,
          chtCustomer: "Customer is required",
        };
      }
    }

    if (taxEntry.chtDefault === 2 || taxEntry.chtDefault === false) {
      if (!taxEntry.chtStakeType || taxEntry.chtStakeType === null) {
        errors = {
          ...errors,
          chtStakeType: "Type is required",
        };
      }
    }
    return errors;
  };
  useEffect(() => {
    if (buttonClicked) {
      setTaxEntry({
        itemTax: null,
        itemReference: "",
        taxName: "",
        status: 2,
        statusLabel: "",
        active: 1,
        activeLabel: "",
        chtDefault: 1,
        chtDefaultLabel: "",
        chtCustomer: null,
        chtCustomerlabel: "",
        chtStakeType: null,
      });

      setButtonClicked(false);
      setCurrentTax({});
    }
  }, [buttonClicked]);

  const resetForm = () => {
    setTaxEntry({
      itemTax: null,
      itemReference: "",
      taxName: "",
      status: 2,
      statusLabel: "",
      active: 1,
      activeLabel: "",
      chtDefault: 1,
      chtDefaultLabel: "",
      chtCustomer: null,
      chtCustomerlabel: "",
      chtStakeType: null,
    });
    customerRef.current.reset();
  };

  console.log("Selected taxes", selectedTaxes);

  const handleAddTax = async () => {
    const errors = validateTaxForm();
    if (Object.keys(errors).length > 0) {
      setItemTaxErrors(errors);
      toast.error("Please fill the required fields", {
        autoClose: 5000,
        containerId: "Main",
      });
      return;
    }

    const v_itemTax = taxEntry.itemTax ? taxEntry.itemTax : null;
    const v_chtDefault = taxEntry.chtDefault ? taxEntry.chtDefault : null;
    const v_chtCustomer = taxEntry.chtCustomer ? taxEntry.chtCustomer : null;
    const v_chtStakeType = taxEntry.chtStakeType ? taxEntry.chtStakeType : null;

    const otherTaxes = selectedTaxes?.filter((item) => {
      if (taxEntry.chtId) {
        return item.chtId !== taxEntry.chtId;
      }
      if (taxEntry.id !== undefined && taxEntry.id !== null) {
        return item.id !== taxEntry.id;
      }
      return true;
    });

    const curr_chtDefault_yes_rows = otherTaxes?.filter(
      (item) => item.chtDefault === 1,
    );

    let shouldBeDisabled = false;
    if (curr_chtDefault_yes_rows?.length > 0) {
      curr_chtDefault_yes_rows?.forEach((item) => {
        if (item.itemTax === v_itemTax && item.chtDefault === v_chtDefault) {
          toast.error("Tax already exists", {
            autoClose: 5000,
            containerId: "Main",
          });
          shouldBeDisabled = true;
          return;
        }
      });

      if (shouldBeDisabled) {
        shouldBeDisabled = false;
        return;
      }
    }

    const curr_chtDefault_no_rows = otherTaxes?.filter(
      (item) => item.chtDefault === 2,
    );

    if (curr_chtDefault_no_rows?.length > 0) {
      curr_chtDefault_no_rows?.forEach((item) => {
        if (item.itemTax === v_itemTax && item.chtDefault === v_chtDefault) {
          if (item.chtStakeType === v_chtStakeType) {
            if (item.chtCustomer === v_chtCustomer) {
              toast.error("Tax already exists", {
                autoClose: 5000,
                containerId: "Main",
              });
              shouldBeDisabled = true;
              return;
            }
          }
        }
      });

      if (shouldBeDisabled) {
        shouldBeDisabled = false;
        return;
      }
    }

    const activeValue = await getTextByValueAndKey("active", taxEntry.active);
    const statusValue = await getTextByValueAndKey("status", taxEntry.status);

    const customerDetails = await getFieldValuesByTableAndId({
      tableName: "masterdata.tms_m_stakeholder",
      primaryKey: "stk_id",
      fieldNames: `stk_name, stk_code`,
      ids: taxEntry.chtCustomer?.toString(),
    });

    const customerName =
      customerDetails && customerDetails.length > 0
        ? customerDetails[0].field1
        : "";

    const taxOption = itemTaxOpt?.find(
      (item) => item.value === taxEntry.itemTax,
    );
    const taxName = taxOption ? taxOption.text : "";

    const buildTaxObject = () => ({
      ...taxEntry,
      taxName: taxName,
      activeLabel: activeValue,
      statusLabel: statusValue,
      chtDefaultLabel: taxEntry.chtDefault === 1 ? "Yes" : "No",
      chtCustomerlabel: customerName,
    });

    if (!taxEntry.chtId) {
      if (!taxEntry.id) {
        setSelectedTaxes((prev) => [
          ...prev,
          { ...buildTaxObject(), id: rowCount },
        ]);
        setRowCount((prev) => prev + 1);
      } else {
        setSelectedTaxes((prev) => [
          ...prev.filter((item) => item.id !== taxEntry.id),
          buildTaxObject(),
        ]);
      }
    } else {
      setSelectedTaxes((prev) => [
        ...prev.filter((item) => item.chtId !== taxEntry.chtId),
        buildTaxObject(),
      ]);
    }

    resetForm();
  };

  useEffect(() => {
    if (taxEntry.chtDefault === 1 || taxEntry.chtDefault === true) {
      customerRef.current.reset();

      setTaxEntry((prev) => ({
        ...prev,
        chtStakeType: null,
        chtCustomer: null,
        chtCustomerlabel: "",
      }));
    }
  }, [taxEntry.chtDefault]);

  console.log("selected taxes", selectedTaxes);

  useEffect(() => {
    if (currentTax && Object.keys(currentTax).length > 0) {
      setTaxEntry({
        ...currentTax,
        chtDefault: currentTax.chtDefault,
        chtDefaultLabel: currentTax.chtDefault === 1 ? "Yes" : "No",
        chtCustomer: currentTax.chtCustomer || null,
        chtCustomerlabel: currentTax.chtCustomerlabel || "",
        chtStakeType: currentTax.chtStakeType || null,
      });

      if (currentTax.chtDefault === 1) {
        customerRef.current.reset();
      }
    }
  }, [currentTax]);

  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <form className="ui form" style={{ overflowY: "auto", height: "75vh" }}>
          <div className="ui segment">
            <h4 className="ui dividing header">Add Tax</h4>
            <div className="two fields">
              {/*<Input*/}
              {/*  required={false}*/}
              {/*  label="Reference"*/}
              {/*  name="reference"*/}
              {/*  onChange={(e) => {*/}
              {/*    setTaxEntry({ ...taxEntry, itemReference: e.target.value });*/}
              {/*  }}*/}
              {/*  value={taxEntry.itemReference}*/}
              {/*  editMode={editMode}*/}
              {/*  disabled={false}*/}
              {/*  field="cht_referance"*/}
              {/*  error={itemTaxErrors.itemTaxReference}*/}
              {/*  resetError={() =>*/}
              {/*    setItemTaxErrors((prevState) => {*/}
              {/*      const { itemTaxReference: _, ...rest } = prevState;*/}
              {/*      return rest;*/}
              {/*    })*/}
              {/*  }*/}
              {/*/>*/}
              <Dropdown
                required={true}
                label="Tax"
                options={itemTaxOpt}
                value={taxEntry.itemTax}
                onChange={(e, data) => {
                  setTaxEntry({ ...taxEntry, itemTax: data.value });
                }}
                editMode={editMode}
                placeholder={"Select Tax"}
                field="cht_charge"
                error={itemTaxErrors.itemTax}
                resetError={() =>
                  setItemTaxErrors((prevState) => {
                    const { itemTax: _, ...rest } = prevState;
                    return rest;
                  })
                }
              />
              <Dropdown
                required={true}
                label="Default"
                options={yesNoOptions}
                value={taxEntry.chtDefault}
                onChange={(e, data) => {
                  setTaxEntry({ ...taxEntry, chtDefault: data.value });
                }}
                editMode={editMode}
                placeholder="Select Yes or No"
                field="cht_default"
                error={itemTaxErrors.chtDefault}
                resetError={() =>
                  setItemTaxErrors((prevState) => {
                    const { chtDefault: _, ...rest } = prevState;
                    return rest;
                  })
                }
              />
            </div>
            <div className="two fields">
              <Dropdown
                required={
                  taxEntry.chtDefault === 2 || taxEntry.chtDefault === false
                }
                label="Type"
                disabled={
                  taxEntry.chtDefault === 1 || taxEntry.chtDefault === true
                }
                options={stakeholderTypes}
                value={taxEntry.chtStakeType}
                onChange={(e, data) => {
                  setTaxEntry({
                    ...taxEntry,
                    chtStakeType: data.value,
                    chtCustomer: null,
                    chtCustomerlabel: "",
                  });
                  customerRef.current.reset();
                }}
                clearable={false}
                editMode={editMode}
                placeholder="Select Stakeholer Type"
                field="cht_stakeholder_type"
                error={itemTaxErrors.chtStakeType}
                resetError={() =>
                  setItemTaxErrors((prevState) => {
                    const { chtStakeType: _, ...rest } = prevState;
                    return rest;
                  })
                }
              />
              <SearchDropdown
                ref={customerRef}
                required={
                  taxEntry.chtDefault === 2 || taxEntry.chtDefault === false
                }
                label="Customer"
                editMode={editMode}
                reset={formFieldReset}
                setReset={setFormFieldReset}
                clearable={true}
                value={taxEntry.chtCustomer}
                onResultSelect={(data) =>
                  setTaxEntry({ ...taxEntry, chtCustomer: data })
                }
                api={getOtherRefSearchDropdown}
                apiDependency={{
                  type: "stakeholder_type",
                  value:
                    taxEntry.chtStakeType === 4
                      ? "Transporter"
                      : "Invoicee Customer",
                }}
                fieldInfo={{
                  tableName: "masterdata.tms_m_stakeholder",
                  primaryKey: "stk_id",
                  fieldName: "stk_name",
                  id: taxEntry.chtCustomer,
                }}
                disabled={
                  taxEntry.chtDefault === 1 ||
                  taxEntry.chtDefault === true ||
                  taxEntry.chtStakeType === null
                }
                placeholder="Select Stakeholer"
                error={itemTaxErrors.chtCustomer}
                resetError={() =>
                  setItemTaxErrors((prevState) => {
                    const { chtCustomer: _, ...rest } = prevState;
                    return rest;
                  })
                }
              />
            </div>
            <div className="two fields">
              <Dropdown
                required={true}
                label="Status"
                options={itemStatusOpt}
                value={taxEntry.status}
                onChange={(e, data) => {
                  setTaxEntry({ ...taxEntry, status: data.value });
                }}
                editMode={editMode}
                placeholder="Status"
                field="cht_status"
                error={itemTaxErrors.itemStatus}
                resetError={() =>
                  setItemTaxErrors((prevState) => {
                    const { itemStatus: _, ...rest } = prevState;
                    return rest;
                  })
                }
              />
              <Dropdown
                required={true}
                label="Active"
                options={itemActiveOpt}
                value={taxEntry.active}
                onChange={(e, data) => {
                  setTaxEntry({ ...taxEntry, active: data.value });
                }}
                editMode={editMode}
                placeholder="Active"
                field="cht_active"
                error={itemTaxErrors.itemActive}
                resetError={() =>
                  setItemTaxErrors((prevState) => {
                    const { itemActive: _, ...rest } = prevState;
                    return rest;
                  })
                }
              />
            </div>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "flex-end",
            }}
          >
            <Button
              template="reset"
              onClick={(e) => {
                setButtonClicked(true);
              }}
            />
            <Button
              template="addOrSave"
              editMode={editMode}
              onClick={handleAddTax}
              create={Object.keys(currentTax).length === 0}
              label={Object.keys(currentTax).length > 0 ? "Update" : "Add"}
              isLoading={isLoading}
            />
          </div>
          <Grid
            content={selectedTaxes}
            config={[
              {
                headerName: "Tax",
                field: "taxName",
              },
              // {
              //   headerName: "Reference",
              //   field: "itemReference",
              // },
              {
                headerName: "Default",
                field: "chtDefaultLabel",
              },
              {
                headerName: "Customer",
                field: "chtCustomerlabel",
                cellRenderer: ResizableScrollingTextRenderer,
              },
              {
                headerName: "Status",
                field: "statusLabel",
                cellRenderer: StatusCellStyle,
              },
              {
                headerName: "Active",
                field: "activeLabel",
                cellRenderer: ActiveCellStyle,
              },
              {
                headerName: "Edit",
                cellRenderer: ButtonRenderer,
                cellRendererParams: (params) => ({
                  clickHandler: () => {
                    setCurrentTax(params.data);
                  },
                  label: "Edit",
                  editMode: editMode,
                }),
              },
              {
                headerName: "Delete",
                cellRenderer: DeleteButtonRenderer,
                cellRendererParams: (params) => ({
                  clickHandler: () => {
                    console.log("Deleting Row:", params.data);
                    if (params.data.chtId) {
                      setSelectedTaxes((prevTaxes) =>
                        prevTaxes.filter(
                          (tax) => tax.chtId !== params.data.chtId,
                        ),
                      );
                    } else {
                      setSelectedTaxes((prevTaxes) =>
                        prevTaxes.filter((tax) => tax.id !== params.data.id),
                      );
                    }

                    setRowCount((prevCount) => prevCount - 1);
                  },
                    message:
                          "Are you sure you want to delete this Tax?",
                  label: "Delete",
                  className: "ui red button",
                }),
              },
            ]}
          />
        </form>
      )}
    </>
  );
});

export default ItemTaxForm;
